export const BALL_SCREW_CSTICS = {
  shaftOrAssembly: "VAMU_095",
  shaftDiameter: "VBGR_095",
  bearingAvailability: "VALK_095",
  lead: "VPSP_095",
  threadLength: "VLGW_095",
  threadLengthMaximum: "VLMAX_095",
  threadLengthMinimum: "VLMIN_095",
  leadPrecision: "VGEN_095",
  material: "VWST_095",
  axialPlayOrPreload: "VPLAY_095",
  nutFamily: "VTYP_095",
  nutVariant: "VMUA_095",
  dustAndDirtProtection: "VWPR_095",
  safetyRing: "VRIN_095",
  recirculationInserts: "VITY_095",
  nutType: "VMBF_095",
  nutOrientation: "VARM_095",
  mountingFlange: "V_FLA_095",
  leftBearingType: "VL_LGK_095",
  rightBearingType: "VR_LGK_095",
  leftLockingNut: "VL_WM_095",
  rightLockingNut: "VR_WM_095",
  leftEndMachining: "VL_END_095",
  rightEndMachining: "VR_END_095",
  endMachiningDiameterD2: "VDIM_D2_095",
  endMachiningDiameterD3: "VDIM_D3_095",
  leftMachinedLength: "VL_LE_095",
  rightMachinedLength: "VR_LE_095",
  leftKeyway: "VL_NUT_095",
  rightKeyway: "VR_NUT_095",
  customCylindricalParts: "VN_ZYL_095",
  customIsoThreads: "VN_ISO_095",
  customMilledParts: "VN_MIL_095",
  customAxialHoles: "VN_AX_095",
} as const;

export const BALL_SCREW_SYNTHETIC_CSTICS = {
  endMachiningMode: "SYNTHETIC_END_MACHINING_MODE_095",
} as const;

/**
 * API CSTICs prepared from KB state but not present in the Ball Screw KB itself.
 */
export const BALL_SCREW_DERIVED_CSTICS = {
  threadLengthHelperText: "DERIVED_VLGW_095_HELPER_TEXT",
} as const;
